import React from "react";
import { StarFilled } from "@ant-design/icons";
import { Slider, Space, Typography } from "antd";

const { Text } = Typography;

export const OCR_DPI_MIN = 200;
export const OCR_DPI_MAX = 360;
export const OCR_DPI_STEP = 10;
export const OCR_DPI_DEFAULT = 200;

export const normalizeOcrDpi = (value, fallback = OCR_DPI_DEFAULT) => {
    const numeric = Number(value);
    if (!Number.isFinite(numeric)) return fallback;
    const stepped = Math.round(numeric / OCR_DPI_STEP) * OCR_DPI_STEP;
    return Math.min(OCR_DPI_MAX, Math.max(OCR_DPI_MIN, stepped));
};

export const resolveOcrOptions = (source) => {
    if (!source || typeof source !== "object") return null;
    if (
        Object.prototype.hasOwnProperty.call(source, "high_resolution_pdf_ocr")
        || Object.prototype.hasOwnProperty.call(source, "pdf_render_dpi")
    ) return source;
    return source.ocr_options || source.structured_data?.meta?.ocr_options || null;
};

export const resolveOcrDpi = (source, fallback = OCR_DPI_DEFAULT) => (
    normalizeOcrDpi(resolveOcrOptions(source)?.pdf_render_dpi, fallback)
);

const OcrDpiSlider = ({ value = OCR_DPI_DEFAULT, onChange, disabled = false }) => {
    const dpi = normalizeOcrDpi(value);
    return (
        <div style={{ marginTop: 12 }}>
            <Space align="baseline" style={{ width: "100%", justifyContent: "space-between" }}>
                <Text strong>渲染分辨率</Text>
                <Text>{dpi} DPI</Text>
            </Space>
            <Slider
                min={OCR_DPI_MIN}
                max={OCR_DPI_MAX}
                step={OCR_DPI_STEP}
                value={dpi}
                onChange={(nextValue) => onChange?.(normalizeOcrDpi(nextValue))}
                disabled={disabled}
                marks={{
                    [OCR_DPI_MIN]: `${OCR_DPI_MIN}`,
                    300: (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 3, whiteSpace: "nowrap" }}>
                            300 <StarFilled style={{ color: "#d4a106", fontSize: 10 }} /> 推荐
                        </span>
                    ),
                    [OCR_DPI_MAX]: `${OCR_DPI_MAX}`,
                }}
                tooltip={{ formatter: (nextValue) => `${nextValue} DPI` }}
                aria-label="OCR 渲染分辨率"
            />
            <Text type="secondary" style={{ fontSize: 12 }}>
                数值越高，小字扫描 PDF 越清晰，但处理时间和资源消耗也会增加。
            </Text>
        </div>
    );
};

export default OcrDpiSlider;
